<div
    class="scan-card"
    [class.active]="!slotVerified()"
    [class.done]="slotVerified()">
    <div class="scan-body">
        <cpw-scan-input
            label="Scan or enter location"
            #slotScanInput
            [barcodeSearchFacade]="locationFacade()"
            [expectedBarcode]="slotBarcode()"
            [disabled]="slotVerified()"
            [value]="verifiedLocationScanValue"
            (barcodeScanned)="onSlotScanned($event)"></cpw-scan-input>
    </div>
</div>

<div
    class="scan-card"
    [class.active]="itemScanEnabled() && !itemVerifiedState()"
    [class.disabled]="!itemScanEnabled()"
    [class.done]="itemVerifiedState()">
    <div class="scan-body">
        <cpw-scan-input
            [label]="verifyItemLabel()"
            #itemScanInput
            [barcodeSearchFacade]="itemOrPalletBarcodeSearchFacade()"
            [expectedBarcode]="itemBarcode()"
            [disabled]="!itemScanEnabled() || itemVerifiedState()"
            [value]="verifiedItemScanValue"
            (barcodeScanned)="onItemScanned($event)"></cpw-scan-input>
        @if (!itemScanEnabled()) {
            <pf-text type="description">Scan the location first.</pf-text>
        }
        @if (itemVerifiedState()) {
            <pf-text type="description">Item scanned.</pf-text>
        }
    </div>
</div>
